/* unplugin-vue-components disabled */import { render } from "./Preferences.vue?vue&type=template&id=83e774d6&ts=true"
import script from "./Preferences.vue?vue&type=script&lang=ts"
export * from "./Preferences.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__